import { z } from 'zod';
import { Supplier } from 'store/suppliers';
import { adminSuppliersFiltersSchema } from './admin-suppliers.schemas';

export interface AdminSupplier extends Supplier {}

export type AdminSuppliersFilters = z.infer<typeof adminSuppliersFiltersSchema>;

export const partnerAdminStatuses = ['active', 'inactive'] as const;
export type PartnerAdminStatus = (typeof partnerAdminStatuses)[number];

export const partnerAdminCognitoStatuses = [
  'linked',
  'unlinkedExists',
  'unlinkedMissing',
] as const;
export type PartnerAdminCognitoStatus =
  (typeof partnerAdminCognitoStatuses)[number];

export interface PartnerAdminCognito {
  username: string;
  sub: string;
  email: string | null;
}

export interface PartnerAdmin {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phone: string;
  status: PartnerAdminStatus;
  root: boolean;
  createdAt: string;
  cognitoStatus?: PartnerAdminCognitoStatus;
  cognito?: PartnerAdminCognito | null;
}

export interface CreatePartnerAdmin {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  root: boolean;
}

export interface UpdatePartnerAdmin {
  firstName?: string;
  lastName?: string;
  phone?: string;
  root?: boolean;
  status?: PartnerAdminStatus;
}

export interface EarningPeriod {
  id: string;
  supplierId: string;
  startsAt: string;
  endsAt: string | null;
  feeBps: number;
  createdAt: string;
  isOpen: boolean;
}
